import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/button';
import { AlertTriangle, X, User } from 'lucide-react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

export function ImpersonationBanner() {
  const { impersonating, impersonator, user, stopImpersonating } = useAuth();
  const navigate = useNavigate();

  if (!impersonating || !impersonator) {
    return null;
  }

  const handleStopImpersonating = async () => {
    try {
      await stopImpersonating();
      toast.success('Returned to your admin account');
      navigate('/admin/users');
    } catch (error) {
      toast.error('Failed to stop impersonating');
    }
  };

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-amber-950 px-4 py-2 shadow-lg"
      data-testid="impersonation-banner"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-5 h-5" />
          <div className="flex items-center gap-2">
            <span className="font-medium">Impersonating:</span>
            <div className="flex items-center gap-1 bg-amber-400/50 px-2 py-0.5 rounded">
              <User className="w-4 h-4" />
              <span className="font-semibold">{user?.name}</span>
              <span className="text-amber-800">({user?.email})</span>
            </div>
            <span className="text-amber-800">•</span>
            <span className="text-sm text-amber-800">
              Logged in as <span className="font-medium">{impersonator?.name}</span>
            </span>
          </div>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={handleStopImpersonating}
          className="bg-white hover:bg-amber-50 text-amber-900 border-amber-600 hover:border-amber-700"
          data-testid="stop-impersonation-btn"
        >
          <X className="w-4 h-4 mr-1" />
          Exit Impersonation
        </Button>
      </div>
    </div>
  );
}
